import {useRoutes} from 'react-router-dom'
import Main from 'src/components/Main'
import SuccessPage from 'src/components/SuccessPage'
import ErrorPage from 'src/components/ErrorPage'

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Main />
    },
    {
      path: '/success/:id',
      element: <SuccessPage />
    },
    {
      path: '/error/:id',
      element: <ErrorPage />
    }
  ])
}
